import {usePlatformUrls} from "../../../core";
import {
  AmVersion,
} from "../../../ps-types";
import {Button as SemanticButton, Icon, Grid, Card, Segment} from "semantic-ui-react";
import { LineItemsStore, QueryResult, StoreQuery } from "../../../ps-models/lineitems-store";
import { Metric } from "../../../statistics/Metric";
import "../../../campaigns/ICP4/ICP4SignUpPage.css";
import { useHistory } from "react-router-dom";
import { AnalysisDetails } from "./AnalysisDetails";
import { LineItemsTableWithFormulas } from "../../../lineitems-store/LineItemsTableView";
import { TimeSeriesChartV2 } from "../../../lineitems-store/TimeSeriesChartV2";

export function PFAResultBlock({store, versionData, QATProjectId}: {store: LineItemsStore, versionData: AmVersion | undefined, QATProjectId: string}){
    let results = store.query(StoreQuery.byNames(['Fund IRR', 'Fund MOIC', 'Developer IRR']))
    const history = useHistory();
    const {dealManagement} = usePlatformUrls();
    return <div>
    <p
    style={{
      color: '#718096',
      fontSize: '16px',
      margin: 0
    }}
    >
      {(results?.lastTimeSlotValueOf('Fund MOIC') as number ?? 0) >= 1.5 && <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px'}}>
            Thank you for your time! The project economics have passed our preliminary check and we are now ready to accept the full information pack. Please continue the process by uploading your your document pack for further review. If needed, we will be in touch.
            <SemanticButton 
              size="large"
              primary
              onClick={()=>history.push(dealManagement())}
              style={{ 
                background: 'linear-gradient(135deg, #480971 0%, #6435C9 100%)',
                border: 'none',
                borderRadius: '12px',
                padding: '18px 36px',
                fontSize: '18px',
                fontWeight: '600',
                boxShadow: '0 6px 20px rgba(72, 9, 113, 0.3)',
                transition: 'all 0.2s ease',
                minWidth: '200px'
              }}
            >
              {'Continue'}
              <Icon name='arrow right' />
            </SemanticButton>
            <Analysis results={results} versionData={versionData} projectId={QATProjectId} />
          </div>}
          {(results?.lastTimeSlotValueOf('Fund MOIC') as number ?? 0) < 1.5 && <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px'}}>
           <div>Thank you for your time! Looks like the project economics did not meet the qualification criteria. Please feel free to check and resubmit. You can also <a href="https://meetings.hubspot.com/arvind-vermani" target="_blank" rel="noopener noreferrer">book a call</a> with us to go over the economics.</div>
            <Analysis results={results} versionData={versionData} projectId={QATProjectId} />
          </div>}
    </p>
      </div>
  
  }

export function CPFATResultBlock({store, versionData, QATProjectId}: {store: LineItemsStore, versionData: AmVersion | undefined, QATProjectId: string}){
  let results = store.query(StoreQuery.byNames(['System Cost and Capital-DSCR', 'System Cost and Capital-MOIC', 'System Cost and Capital-Project Post Tax IRR']))

    const isProjectEconomicsPassed = (results?.lastTimeSlotValueOf('System Cost and Capital-DSCR') as number ?? 0 >= 1) && (results?.lastTimeSlotValueOf('System Cost and Capital-MOIC') as number ?? 0 >= 1.2) && (results?.lastTimeSlotValueOf('System Cost and Capital-Project Post Tax IRR') as number ?? 0 >= 0.08);
    const isProjectEconomicsFailed = !isProjectEconomicsPassed;
    return <div>
    <p
    style={{
      color: '#718096',
      fontSize: '16px',
      margin: 0
    }}
    >
      {Boolean(isProjectEconomicsPassed) && <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px'}}>
      Congratulations! Your project meets our financing qualification criteria. We will be in touch with the detailed cashflow projections model and next steps in the next 24-48 hours.
          </div>}
      {Boolean(isProjectEconomicsFailed) && <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px'}}>
        <div>
        Unfortunately, it seems your project did not meet our financing qualification criteria. We may be able to help you improve the project economics and help secure financing. Please schedule a time to meet with us using this <a href="https://meetings.hubspot.com/arvind-vermani" target="_blank" rel="noopener noreferrer">link</a>.
      </div>
      </div>}
    </p>
      </div>
  
  }  

export function ProjectPricingResultBlock({store, versionData, QATProjectId}: {store: LineItemsStore, versionData: AmVersion | undefined, QATProjectId: string}){
    return <div>
    <p
    style={{
      color: '#718096',
      fontSize: '16px',
      margin: 0
    }}
    >
      {<div>
        <ProjectPricingAnalysis store={store} versionData={versionData} projectId={QATProjectId} />
      </div>}
      </p>
      </div>
  
  }
  
  export function ProjectCreationResultBlock({store, versionData, QATProjectId}: {store: LineItemsStore, versionData: AmVersion | undefined, QATProjectId: string}){
    const history = useHistory();
    const {amProjectDetails} = usePlatformUrls();
    return <div>
    <p
    style={{
      color: '#718096',
      fontSize: '16px',
      margin: 0
    }}
    >
      {<div>
        <SemanticButton 
              size="large"
              primary
              onClick={()=>history.push(amProjectDetails(QATProjectId))}
              style={{ 
                background: 'linear-gradient(135deg, #480971 0%, #6435C9 100%)',
                border: 'none',
                borderRadius: '12px',
                padding: '18px 36px',
                fontSize: '18px',
                fontWeight: '600',
                boxShadow: '0 6px 20px rgba(72, 9, 113, 0.3)',
                transition: 'all 0.2s ease',
                minWidth: '200px'
              }}
            >
              {'View Project'}
              <Icon name='arrow right' />
            </SemanticButton>
      </div>}
      </p>
      </div>
  }
  
export function QATMetricCard({label, value}: {label: string, value: string}){
    return         <Card style={{ 
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      border: 'none',
      color: 'white',
      width:'100%'
    }}>
      <Card.Content style={{ padding: '32px', textAlign: 'center' }}>
      <Metric size="small" label={label} value={value} />
      </Card.Content>
    </Card>
  }
  
  export function Analysis({results, versionData, projectId}: {results: QueryResult, versionData: AmVersion | undefined, projectId: string}){
    return <AnalysisDetails versionData={versionData} projectId={projectId} variant="on-btn-click">
        <Grid stackable>
        <Grid.Column mobile={16} tablet={16} computer={5}>
          <QATMetricCard label="Fund IRR" value={results.lastTimeSlotTextOf('Fund IRR')} />
        </Grid.Column>
        
        <Grid.Column mobile={16} tablet={16} computer={5}>
          <QATMetricCard label="Fund MOIC" value={results.lastTimeSlotTextOf('Fund MOIC')} />
        </Grid.Column>
        
        <Grid.Column mobile={16} tablet={16} computer={5}>
        <QATMetricCard label="Developer IRR" value={results.lastTimeSlotTextOf('Developer IRR')} />
        </Grid.Column>
      </Grid>
    </AnalysisDetails>
  }
  
  function ProjectPricingAnalysis({store, versionData, projectId}: {store: LineItemsStore, versionData: AmVersion | undefined, projectId: string}){
    console.info("The store is", JSON.stringify(store.getDataSet().getLineItems(), undefined, 4))
    const tableQueryResult = store.query(StoreQuery.byNames(['PPA Revenue', 'Other Revenue', 'Opex', 'Debt Service', 'Net Cash Flow', 'Total Cash Flow']))
    return <AnalysisDetails versionData={versionData} projectId={projectId} variant="rendered-as-is">
        <Grid stackable width="100%">
        <Grid.Column mobile={16} tablet={16} computer={5}>
        <QATMetricCard label="Optimal PPA Rate ($/kWh)" value={store.query(StoreQuery.byNames(['Optimal PPA Rate ($/kWh)'])).lastTimeSlotTextOf('Optimal PPA Rate ($/kWh)')} />
        </Grid.Column>
        <Segment basic style={{width: '100%'}}>
          <LineItemsTableWithFormulas store={store}
          queryResult={tableQueryResult}
        />      
        </Segment>
        <Segment basic style={{width: '100%'}}>
        <TimeSeriesChartV2 title={""}
                       options={{type: "bar",
                         granularity: store.timeIndex.getUnit(),
                      //  ...(config?.plotAtLastDatesOfPeriod !==undefined ? {plotAtLastDatesOfPeriod: config.plotAtLastDatesOfPeriod}: {}),
                      //  ...((Array.isArray(config?.lineItemSeriesDefinitionOverrides) && config.lineItemSeriesDefinitionOverrides.length>0) ? {lineItemSeriesDefinitionOverrides: config.lineItemSeriesDefinitionOverrides }: {})
                       }}
                       result={tableQueryResult}
        />
        </Segment>
      </Grid>
    </AnalysisDetails>
  }